(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ajax-cart-new"] && !Shopify.designMode) return;
  try {
    
  if (!document.querySelector('.new-cart')) {
    // Classes
    const acNewCls = 'ac-new';
    const acNewActiveCls = 'ac-new--active';
    const acNewBoxCls = 'ac-new__box';
    const acNewLoadingCls = 'ac-new__loading';
    const acNewLoadingActiveCls = 'ac-new__loading--active';
    const acNewHeaderCloseCls = 'ac-new-header__close';
    const acNewMainCls = 'ac-new__main';
    const acNewItemsCls = 'ac-new__items';
    const acNewFooterCls = 'ac-new-footer';
    const acNewPairingCls = 'ac-new-pairing';
    const acNewPairingImgCls = 'ac-new-pairing__img';
    const acNewPairingPriceCls = 'ac-new-pairing__price';
    const acNewPairingSelectCls = 'ac-new-pairing__select';
    const acNewPairingAddCls = 'ac-new-pairing__add';
    const acNewPairingFormCls = 'ac-new-pairing__main-bottom';
    const acNewRemoveCls = 'ac-new-item__remove';
    const acNewQuantityUpCls = 'ac-new-selector__plus';
    const acNewQuantityDownCls = 'ac-new-selector__minus';
    const acNewSelectorCls = 'ac-new-selector';
    const acNewSelectorInputCls = 'ac-new-selector__input';
    const acNewFooterShippingCls = 'ac-new-footer__row--shipping';
    const acNewFooterShippingActiveCls = 'ac-new-footer__row--active';
    const acNewAnnouncementTextCls = 'ac-new-announcement__text';
    const acDiscountCodeCls = 'ac-new-discount-code';
    const acDiscountCodeRemoveCls = 'ac-new-discount-code__remove';
    const acDiscountCodeNameCls = 'ac-new-discount-code__name';
    const acSubmitCodeFormCls = 'ac-new-discounts__form';
    const acSubmitCodeFormInputCls = 'ac-new-discounts__input';
    const acSubmitCodeFormButtonCls = 'ac-new-discounts__button';
    const acSubmitCodeFormErrorCls = 'ac-new-discounts__error';
    const acSubmitCodeFormErrorActiveCls = 'ac-new-discounts__error--active';
    const acNewGwCls = 'ac-new-giftwrap';
    const acNewGwActiveCls = 'ac-new-giftwrap--active';
    const acNewGwHeaderCls = 'ac-new-giftwrap__header';
    const acNewGwBodyCls = 'ac-new-giftwrap__body';
    const acNewGwMinusCls = 'ac-new-gw-selector__minus';
    const acNewGwPlusCls = 'ac-new-gw-selector__plus';
    const acNewGwInputCls = 'ac-new-gw-selector__input';
    const acNewGwFormCls = 'ac-new-giftwrap-prod__bottom';
    const acNewGnCls = 'ac-new-giftnote';
    const acNewGnActiveCls = 'ac-new-giftnote--active';
    const acNewGnHeaderCls = 'ac-new-giftnote__header';
    const acNewGnBodyCls = 'ac-new-giftnote__body';
    const acNewGnNoteCls = 'ac-new-giftnote__note';

    // Selectors
    const acRoot = document.querySelector(`.${acNewCls}`);
    const acCartAnchors = document.querySelectorAll('a[href^="/cart"]');
    const acProductForms = document.querySelectorAll(':not(.ac-new) form[action^="/cart/add"]');
    const headerCount = document.querySelector('#header-cart-count');
    const acAnnouncementText = acRoot.querySelector(`.${acNewAnnouncementTextCls}`);

    // Data
    const acMoneyFormat = acRoot.getAttribute('data-money-format');
    const acMoneyFormatExample = acRoot.getAttribute('data-money-format-example');
    const acCountry = acRoot.getAttribute('data-country');

    // State
    const acDebounceTimers = {};
    let acScrollPosition = 0;

    // Temp selectors
    let acClose,
      acMain,
      acItems,
      acFooter,
      acPairings,
      acBox,
      acRemoves,
      acLoading,
      acQuantityUps,
      acQuantityDowns,
      acDiscountCodes,
      acSubmitCodeForm,
      acSubmitCodeFormInput,
      acSubmitCodeFormButton,
      acSubmitCodeError,
      acNewGw,
      acNewGwHeader,
      acNewGwBody,
      acNewGwMinus,
      acNewGwPlus,
      acNewGwInput,
      acNewGwForm,
      acNewGn,
      acNewGnHeader,
      acNewGnBody,
      acNewGnNote;

    // Assign event listeners
    acRoot.addEventListener('click', (e) => acCloseCart());
    // acCartAnchors.forEach((el) => {
    //   el.addEventListener('click', (e) => {
    //     e.preventDefault()
    //     acOpenCart()
    //   })
    // })

    acProductForms.forEach((form) => {
      form.addEventListener('submit', (e) => acHandleAdd(e));
    });

    document.addEventListener('mouseup', (e) => {
      if (
        e.target.matches('.bndlr-add-to-cart') ||
        e.target.matches('.bndlr-add-bundle-to-cart') ||
        e.target.matches('.bndlr-add-sectioned-bundle-to-cart')
      ) {
        acOpenCart();

        setTimeout(() => {
          acUpdateContent();
        }, 600);

        setTimeout(() => {
          acUpdateContent();
        }, 1200);
      }
    });

    // Assign temp event listeners
    setSelectorsAndEvents();

    // Update the bundlr total
    document.addEventListener('bundler:loaded', () => {
      try {
        if (acRoot.getAttribute('data-bundle')) window.bndlr.updateCartDiscounts();
      } catch (e) {
        console.info(e);
      }
    });

    // Methods
    function setupGiftnote() {
      acNewGn = acRoot.querySelector(`.${acNewGnCls}`);

      if (acNewGn) {
        acNewGnHeader = acNewGn.querySelector(`.${acNewGnHeaderCls}`);
        acNewGnBody = acNewGn.querySelector(`.${acNewGnBodyCls}`);
        acNewGnNote = acNewGn.querySelector(`.${acNewGnNoteCls}`);

        // Slide toggle
        acNewGnHeader.addEventListener('click', () => {
          acNewGn.classList.toggle(acNewGnActiveCls);

          if (acNewGn.classList.contains(acNewGnActiveCls)) {
            acNewGnBody.style.maxHeight = acNewGnBody.scrollHeight + 'px';

            if (acMain) acMain.scrollTop = acMain.scrollHeight;
          } else {
            acNewGnBody.style.maxHeight = '0px';
          }
        });

        //set note
        let noteTimer;
        acNewGnNote.addEventListener('keyup', (e) => {
          clearTimeout(noteTimer);

          noteTimer = setTimeout(() => {
            const noteText = acNewGnNote.value.trim();

            fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ note: noteText }),
            })
              .then((res) => {
                if (!res.ok) throw new Error(`Failed to update cart note: ${res.status}`);
              })
              .catch((err) => {
                console.error('Cart note update error:', err);
              });
          }, 500);
        });
      }
    }

    function setupGiftwrap() {
      acNewGw = acRoot.querySelector(`.${acNewGwCls}`);

      if (acNewGw) {
        acNewGwHeader = acNewGw.querySelector(`.${acNewGwHeaderCls}`);
        acNewGwBody = acNewGw.querySelector(`.${acNewGwBodyCls}`);
        acNewGwMinus = acNewGw.querySelector(`.${acNewGwMinusCls}`);
        acNewGwPlus = acNewGw.querySelector(`.${acNewGwPlusCls}`);
        acNewGwInput = acNewGw.querySelector(`.${acNewGwInputCls}`);
        acNewGwForm = acNewGw.querySelector(`.${acNewGwFormCls}`);

        // Slide toggle
        acNewGwHeader.addEventListener('click', () => {
          acNewGw.classList.toggle(acNewGwActiveCls);

          if (acNewGw.classList.contains(acNewGwActiveCls)) {
            acNewGwBody.style.maxHeight = acNewGwBody.scrollHeight + 'px';
            if (acMain) acMain.scrollTop = acMain.scrollHeight;
          } else {
            acNewGwBody.style.maxHeight = '0px';
          }
        });

        // Down
        acNewGwMinus.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(acNewGwInput.value, 10) || 1;
          if (val > 1) {
            acNewGwInput.value = val - 1;
          }
        });

        // Up
        acNewGwPlus.addEventListener('click', (e) => {
          e.preventDefault();
          let val = parseInt(acNewGwInput.value, 10) || 1;
          acNewGwInput.value = val + 1;
        });

        // Add
        acNewGwForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          acLoadingOn();

          const variantId = acNewGwForm.querySelector('input[name="id"]').value;
          const quantity = parseInt(acNewGwInput.value, 10) || 1;

          try {
            const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: quantity,
                  },
                ],
              }),
            });

            if (!res.ok) {
              throw new Error(`Giftwrap add failed: ${res.status}`);
            }

            await acUpdateContent();
            acOpenCart();

            try {
              const formData = new FormData(acNewGwForm);
              const id = formData.get('product-id');
              wunderkindSDK('addToCart', { 'item:id': `${id}` });
            } catch (err) {
              console.log('Failed to send wunderkind data', err);
            }
          } catch (err) {
            console.error('Error adding giftwrap:', err);
          } finally {
            acLoadingOff();
          }
        });
      }
    }

    function setSelectorsAndEvents() {
      // Set selectors
      acBox = document.querySelector(`.${acNewBoxCls}`);
      acMain = acBox.querySelector(`.${acNewMainCls}`);
      acClose = acBox.querySelector(`.${acNewHeaderCloseCls}`);
      acItems = acBox.querySelector(`.${acNewItemsCls}`);
      acFooter = acBox.querySelector(`.${acNewFooterCls}`);
      acRemoves = acBox.querySelectorAll(`.${acNewRemoveCls}`);
      acPairings = acBox.querySelectorAll(`.${acNewPairingCls}`);
      acLoading = acBox.querySelector(`.${acNewLoadingCls}`);
      acQuantityUps = acBox.querySelectorAll(`.${acNewQuantityUpCls}`);
      acQuantityDowns = acBox.querySelectorAll(`.${acNewQuantityDownCls}`);
      acDiscountCodes = acBox.querySelectorAll(`.${acDiscountCodeCls}`);
      acSubmitCodeForm = acBox.querySelector(`.${acSubmitCodeFormCls}`);
      acSubmitCodeFormButton = acBox.querySelector(`.${acSubmitCodeFormButtonCls}`);
      acSubmitCodeFormInput = acBox.querySelector(`.${acSubmitCodeFormInputCls}`);
      acSubmitCodeError = acBox.querySelector(`.${acSubmitCodeFormErrorCls}`);

      // Set event listeners
      acBox.addEventListener('click', (e) => e.stopPropagation());
      acClose.addEventListener('click', (e) => acCloseCart());

      acRemoves.forEach((remove) => {
        remove.addEventListener('click', (e) => acHandleRemove(e));
      });

      acQuantityUps.forEach((up) => {
        up.addEventListener('click', (e) => acHandleQuantityChange(e, false));
      });

      acQuantityDowns.forEach((down) => {
        down.addEventListener('click', (e) => acHandleQuantityChange(e, true));
      });

      acPairings.forEach((pairing) => {
        const acPairingSelect = pairing.querySelector(`.${acNewPairingSelectCls}`);
        const acPairingForm = pairing.querySelector(`.${acNewPairingFormCls}`);

        acPairingSelect.addEventListener('change', (e) => acHandlePairingVariantChange(e, pairing));
        acPairingForm.addEventListener('submit', (e) => acHandleAdd(e));
      });

      acDiscountCodes.forEach((codeEl) => {
        const nameEl = codeEl.querySelector(`.${acDiscountCodeNameCls}`);
        const removeBtn = codeEl.querySelector(`.${acDiscountCodeRemoveCls}`);
        if (!nameEl || !removeBtn) return;

        const codeToRemove = nameEl.textContent.trim().toUpperCase();

        removeBtn.addEventListener('click', () => acRemoveDiscountCode(codeToRemove));
      });

      if (acSubmitCodeFormButton && acSubmitCodeFormInput) {
        acSubmitCodeForm.addEventListener('submit', (e) => acAddDiscountCode(e));
      }

      setupGiftwrap();
      setupGiftnote();
    }

    async function acAddDiscountCode(e) {
      e.preventDefault();

      const newCode = acSubmitCodeFormInput.value.trim().toUpperCase();
      if (!newCode) return;

      try {
        acLoadingOn();

        // Clear previous error
        acSubmitCodeError.textContent = '';
        acSubmitCodeError.classList.remove(acSubmitCodeFormErrorActiveCls);

        // Collect existing codes from DOM
        const existingCodes = Array.from(acDiscountCodes)
          .map((el) => el.querySelector(`.${acDiscountCodeNameCls}`)?.textContent.trim().toUpperCase())
          .filter(Boolean);

        // Avoid duplicate application
        if (existingCodes.includes(newCode)) {
          acSubmitCodeError.textContent = 'Code already applied';
          acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
          acLoadingOff();
          return;
        }

        // 3. Combine and apply all codes
        const allCodes = [...existingCodes, newCode];

        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: allCodes.join(',') }),
        });

        const json = await res.json();

        //  Check if the new code was actually applied
        const applied = json.discount_codes?.find((d) => d.code.toUpperCase() === newCode && d.applicable);

        if (!applied) {
          acSubmitCodeError.textContent = 'Code already applied or invalid';
          acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
          acLoadingOff();
          return;
        }

        await acUpdateContent();
      } catch (err) {
        acSubmitCodeError.textContent = 'Failed to apply discount code';
        acSubmitCodeError.classList.add(acSubmitCodeFormErrorActiveCls);
        acLoadingOff();
      }
    }

    async function acRemoveDiscountCode(codeToRemove) {
      try {
        // Get remaining codes
        const remainingCodes = Array.from(acDiscountCodes)
          .map((el) => el.querySelector(`.${acDiscountCodeNameCls}`)?.textContent.trim().toUpperCase())
          .filter((code) => code && code !== codeToRemove);

        // Send the post to remove
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        });

        // Update ui
        await acUpdateContent();
      } catch (err) {
        console.error('Failed to update discount codes:', err);
      }
    }

    window.acOpenCart = function acOpenCart() {
      acScrollPosition = window.scrollY || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${acScrollPosition}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      acRoot.classList.add(acNewActiveCls);
    };

    function acCloseCart() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, acScrollPosition);
      acRoot.classList.remove(acNewActiveCls);
    }

    function acLoadingOn() {
      acLoading.classList.add(acNewLoadingActiveCls);
    }

    function acLoadingOff() {
      acLoading.classList.remove(acNewLoadingActiveCls);
    }

    async function acHandleQuantityChange(e, isDown) {
      e.preventDefault();
      acLoadingOn();

      // Get info
      const root = e.target.closest('.ac-new-item');
      const key = root.getAttribute('data-key');
      const embroideryKey = root.getAttribute('data-embroidery-key'); // same key on every embroidered row
      const selector = e.target.closest(`.${acNewSelectorCls}`);
      const input = selector.querySelector(`.${acNewSelectorInputCls}`);
      const currentValue = Number(input.value);
      let newValue = isDown ? currentValue - 1 : currentValue + 1;

      if (newValue < 0) newValue = 0;

      // Update the input right away
      input.value = newValue;

      // If there is an existing timer, clear it
      if (acDebounceTimers[key]) {
        clearTimeout(acDebounceTimers[key]);
      }

      // Start a new debounce timer
      acDebounceTimers[key] = setTimeout(async () => {
        try {
          const updates = {
            [key]: newValue,
          };

          // ──> compute the combined embroidery qty across the whole cart
          if (embroideryKey) {
            let combinedEmbQty = 0;
            document.querySelectorAll('.ac-new-item[data-has-embroidery]').forEach((item) => {
              const qtyInput = item.querySelector(`.${acNewSelectorInputCls}`);
              if (qtyInput) combinedEmbQty += Number(qtyInput.value);
            });
            updates[embroideryKey] = combinedEmbQty;
          }

          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
          });

          if (!res.ok) {
            throw new Error(`Request failed: ${res.status}`);
          }

          // Refresh cart UI
          acUpdateContent();
        } catch (err) {
          console.error('Error updating quantity:', err);
        } finally {
          // Clean up the timer
          delete acDebounceTimers[key];
        }
      }, 400); // 400ms debounce
    }

    window.acUpdateContent = async function acUpdateContent() {
      console.log('Updating ajax cart');
      // Check current cart for things
      const gwIsOpen = acNewGw ? acNewGw.classList.contains(acNewGwActiveCls) : false;
      const gnIsOpen = acNewGn ? acNewGn.classList.contains(acNewGnActiveCls) : false;

      // Fetch new cart section
      const html = await fetch('/?section_id=ajax-cart-new&country=' + acCountry).then((r) => r.text());

      // Created a dom
      const dom = document.createElement('div');
      dom.innerHTML = html;

      // update cart count
      const root = dom.querySelector(`.${acNewCls}`);
      const cartCount = root.getAttribute('data-cart-count');
      headerCount.textContent = cartCount;

      // Copy announcement text
      const announcementText = root.querySelector(`.${acNewAnnouncementTextCls}`);
      if (announcementText) announcementText.innerHTML = acAnnouncementText.innerHTML;

      // International changes
      // if (acInUs) {
      //   const shippingRow = dom.querySelector(`.${acNewFooterShippingCls}`)
      //   if (shippingRow) shippingRow.classList.remove(acNewFooterShippingActiveCls)
      // } else {
      //   const progressEl = dom.querySelector(`.${acNewProgressCls}`)
      //   if (progressEl) {
      //     progressEl.remove()
      //   }
      // }

      // If the giftwrap was open open on new
      if (acNewGw && gwIsOpen) {
        const gw = dom.querySelector(`.${acNewGwCls}`);
        const gwBody = dom.querySelector(`.${acNewGwBodyCls}`);
        if (gw && gwBody) {
          gw.classList.add(acNewGwActiveCls);
          gwBody.style.maxHeight = '100px';
        }
      }

      if (acNewGn && gnIsOpen) {
        const gn = dom.querySelector(`.${acNewGnCls}`);
        const gnBody = dom.querySelector(`.${acNewGnBodyCls}`);
        if (gn && gnBody) {
          gn.classList.add(acNewGnActiveCls);
          gnBody.style.maxHeight = '120px';
        }
      }

      // Swap content
      // ─────────────────────────────────────────────
      // Preserve BOGOs progress before DOM replacement
      // ─────────────────────────────────────────────
      const existingBogosHTML = acRoot.querySelector('.ac-new-gift-progress')?.innerHTML || null;

      // Swap content
      const box = acRoot.querySelector(`.${acNewBoxCls}`);
      const newBox = dom.querySelector(`.${acNewBoxCls}`);
      if (!box || !newBox) return;
      box.innerHTML = newBox.innerHTML;

      // ─────────────────────────────────────────────
      // Restore BOGOs progress after DOM replacement
      // ─────────────────────────────────────────────
      if (existingBogosHTML) {
        const newBogosContainer = acRoot.querySelector('.ac-new-gift-progress');
        if (newBogosContainer) {
          newBogosContainer.innerHTML = existingBogosHTML;
        }
      }

      // Set new event listeners
      setSelectorsAndEvents();

      acLoadingOff();

      // Update bundler discounts
      try {
        window.bndlr.updateCartDiscounts();
      } catch (e) {
        console.info(e);
      }

      // Send wunderkind event
      try {
        const empty = document.querySelector('.ac-new-empty');
        if (empty) wunderkindSDK('emptyCart', {});
      } catch (err) {
        console.log('Failed to send wunderkind data', err);
      }
    };

    async function acHandleAdd(e) {
      // Stop default
      e.preventDefault();

      // Show spinner
      acLoadingOn();

      // Get the data
      const form = e.target;
      const formData = new FormData(form);
      const formBody = new URLSearchParams(formData).toString();
      const hasEmbroidery = formBody.indexOf('Embroidery') > -1;

      // Disabled submit
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) submitButton.disabled = true;

      try {
        // Send the post
        const response = await fetch(form.action, {
          method: form.method,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formBody,
        });

        if (hasEmbroidery) {
          const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: 40890756530242,
                  quantity: 1,
                },
              ],
            }),
          });
        }

        if (!response.ok) {
          throw new Error(`Request failed (${response.status})`);
        }

        acOpenCart();
        acUpdateContent();

        try {
          const formData = new FormData(form);
          const id = formData.get('id');
          wunderkindSDK('addToCart', { 'item:id': `${product.id}` });
        } catch (err) {
          console.log('Failed to send wunderkind data', err);
        }
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    }

    async function acHandleRemove(e) {
      // Stop default
      e.preventDefault();

      // Show spinner
      acLoadingOn();

      try {
        // Get the key
        const root = e.target.closest('.ac-new-item');
        const key = root.getAttribute('data-key');

        // Remove from the dom
        root.remove();

        // Send the req
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        acUpdateContent();
      } catch (err) {
        console.log(err);
      }
    }

    function acHandlePairingVariantChange(e, pairing) {
      e.preventDefault();

      try {
        const newValue = e.target.value;
        const acPairingJsonRaw = pairing.getAttribute('data-json');
        const acPairingJson = JSON.parse(acPairingJsonRaw);
        const acPairingImg = pairing.querySelector(`.${acNewPairingImgCls}`);
        const acPairingPrice = pairing.querySelector(`.${acNewPairingPriceCls}`);
        const acPairingAdd = pairing.querySelector(`.${acNewPairingAddCls}`);
        const newVariant = acPairingJson.variants.find((v) => v.id === Number(newValue));
        if (!newVariant) return;

        // Update image
        if (newVariant.featured_image) {
          acPairingImg.src = newVariant.featured_image.src + '&width=130';
        } else {
          acPairingImg.src = acPairingJson.featured_image + '&width=130';
        }

        // Update price
        const newPrice = fmoney(acMoneyFormat, acMoneyFormatExample, newVariant.price);
        acPairingPrice.textContent = newPrice;

        // Update add
        if (newVariant.available) {
          acPairingAdd.disabled = false;
          acPairingAdd.textContent = 'Add';
        } else {
          acPairingAdd.disabled = true;
          acPairingAdd.textContent = 'Unavailable';
        }
      } catch (err) {
        console.log(err);
      }
    }

    function fmoney(moneyFormatString, moneyFormatExample, cents, removeTrailingZeros = true) {
      // Calculate raw amount
      const amount = (cents / 100).toFixed(2);
      const amount_no_decimals = Math.round(cents / 100).toString();

      // Extract separators from example (e.g. "12,345,678.90" or "12.345.678,90")
      const match = moneyFormatExample.match(/(\d{2,3})([^0-9])(\d{3})([^0-9])\d{2}$/);

      let thousandsSep = ',';
      let decimalSep = '.';

      if (match) {
        thousandsSep = match[2];
        decimalSep = match[4];
      } else {
        // Fallback in case example isn't in expected form
        console.log('Could not parse moneyFormatExample, using defaults');
      }

      // Helper to format amount with correct separators
      function formatAmount(amountStr) {
        let [intPart, decPart] = amountStr.split('.');
        const intWithSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);

        if (removeTrailingZeros && decPart !== undefined) {
          decPart = decPart.replace(/0+$/, ''); // Remove trailing zeros
          if (decPart === '') {
            return intWithSep; // No decimal part left
          }
        }

        return decPart !== undefined ? intWithSep + decimalSep + decPart : intWithSep;
      }

      const formattedAmount = formatAmount(amount);
      const formattedAmountNoDecimals = formatAmount(amount_no_decimals);

      // Replace placeholders
      return moneyFormatString
        .replace('{{amount}}', formattedAmount)
        .replace('{{amount_no_decimals}}', formattedAmountNoDecimals);
    }

    // Bogos booster position
    try {
      console.log('BOGOS!!!!');

      Shopify.scaHandleConfigValue = {
        bogos_progressing_bar_query: '.ac-new-gift-progress',
        bogos_custom_progress_position: 'in', //before/in/after,
      };
    } catch (err) {}
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrier-comparison"] && !Shopify.designMode) return;
  try {
    
  const table = document.querySelector('.carrier-compare-table')
  if (!table) return

  const selects = table.querySelectorAll('.carrier-compare-table__header-select')

  function updateDisabledOptions() {
    // find both active columns
    const activeCols = Array.from(table.querySelectorAll('.carrier-compare-table__column--active'))

    if (activeCols.length !== 2) return

    const [colA, colB] = activeCols
    const selA = colA.querySelector('.carrier-compare-table__header-select')
    const selB = colB.querySelector('.carrier-compare-table__header-select')

    // in select A → disable the value of select B
    Array.from(selA.options).forEach((opt) => {
      opt.disabled = opt.value === selB.value
    })

    // in select B → disable the value of select A
    Array.from(selB.options).forEach((opt) => {
      opt.disabled = opt.value === selA.value
    })
  }

  function handleSelectChange(e) {
    const select = e.target
    const column = select.closest('.carrier-compare-table__column')
    const selectedValue = select.value

    // find the real column for that product
    const targetCol = table.querySelector(`.carrier-compare-table__column[data-product="${selectedValue}"]`)
    if (!targetCol) return

    // swap: remove active from current column, add active to target column
    column.classList.remove('carrier-compare-table__column--active')
    targetCol.classList.add('carrier-compare-table__column--active')

    // reorder DOM so the swapped-in col takes the place of the old one
    table.insertBefore(targetCol, column)

    updateDisabledOptions()
  }

  selects.forEach((select) => {
    select.addEventListener('change', handleSelectChange)
  })

  updateDisabledOptions()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs-new"] && !Shopify.designMode) return;
  try {
    
  const faqQuestions = document.querySelectorAll('.faq-new-question')

  faqQuestions.forEach((faq) => {
    const header = faq.querySelector('.faq-new-question__header')
    const body = faq.querySelector('.faq-new-question__body')
    const bodyInner = faq.querySelector('.faq-new-question__body-inner')

    header.addEventListener('click', function () {
      const isActive = faq.classList.contains('faq-new-question--active')

      // Close all FAQs first (if you want accordion behavior — remove this if you want multiple open)
      faqQuestions.forEach((f) => {
        f.classList.remove('faq-new-question--active')
        f.querySelector('.faq-new-question__body').style.maxHeight = '0'
      })

      if (!isActive) {
        faq.classList.add('faq-new-question--active')
        body.style.maxHeight = bodyInner.scrollHeight + 'px'
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-drawer"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const drawer = document.querySelector('.gift-drawer')
    const form = document.querySelector('.gift-drawer__box')
    const closeBtn = document.querySelector('.gift-drawer__close')
    const contactFieldWrapper = document.querySelector('.gift-drawer-field--contact')
    const contactInput = document.querySelector('#contact')
    const errorP = document.querySelector('.gift-drawer__error')
    const successP = document.querySelector('.gift-drawer__success')

    if (!drawer || !form) return

    const FORMSPARK_URL = 'https://submit-form.com/I1uVyIlrS'

    /* ---------------------------
     OPEN/CLOSE HELPERS
  --------------------------- */
    function openDrawer() {
      drawer.classList.add('gift-drawer--active')
    }

    function closeDrawer() {
      drawer.classList.remove('gift-drawer--active')
    }

    /* ---------------------------
     OPEN ON .open-gift-drawer CLICK
  --------------------------- */
    document.querySelectorAll('.open-gift-drawer').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        openDrawer()
      })
    })

    /* ---------------------------
     CLICK OUTSIDE → CLOSE
  --------------------------- */
    drawer.addEventListener('click', (e) => {
      if (!form.contains(e.target)) {
        closeDrawer()
      }
    })

    /* ---------------------------
     X BUTTON → CLOSE
  --------------------------- */
    closeBtn.addEventListener('click', () => {
      closeDrawer()
    })

    /* ---------------------------
     CONTACT METHOD SWITCHER
  --------------------------- */
    const contactMethodInputs = document.querySelectorAll("input[name='contact-method']")
    contactMethodInputs.forEach((input) => {
      input.addEventListener('change', (e) => {
        const value = e.target.value

        contactFieldWrapper.classList.remove('gift-drawer-field--mobile', 'gift-drawer-field--email')

        if (value === 'Mobile') {
          contactFieldWrapper.classList.add('gift-drawer-field--mobile')
        } else if (value === 'Email') {
          contactFieldWrapper.classList.add('gift-drawer-field--email')
        }
      })
    })

    /* ---------------------------
     AJAX SUBMIT → FORM SPARK
  --------------------------- */
    form.addEventListener('submit', async (e) => {
      e.preventDefault()

      // Reset success message from previous submissions
      successP.classList.remove('gift-drawer__success--active')

      // Clear old error
      errorP.textContent = ''
      errorP.classList.remove('gift-drawer__error--active')

      // Gather values
      const selectedFor = form.querySelector("input[name='for']:checked")
      const selectedAge = form.querySelector("input[name='age']:checked")
      const selectedContactMethod = form.querySelector("input[name='contact-method']:checked")
      const occasion = form.querySelector('#occasion').value
      const budget = form.querySelector("input[name='budget']:checked")?.value || ''
      const contactValue = contactInput.value.trim()
      const firstName = form.querySelector('#first_name').value.trim()
      const lastName = form.querySelector('#last_name').value.trim()

      // Validation
      if (
        !firstName ||
        !lastName ||
        !selectedFor ||
        !selectedAge ||
        !occasion ||
        !selectedContactMethod ||
        !contactValue
      ) {
        errorP.textContent = 'Please complete all required fields.'
        errorP.classList.add('gift-drawer__error--active')
        return
      }

      // Build form data
      const payload = {
        'First Name': firstName,
        'Last Name': lastName,
        'Gift For': selectedFor.value,
        'Baby Age': selectedAge.value,
        'Gifting Occasion': occasion,
        Budget: budget,
        'Contact Method': selectedContactMethod.value,
        Contact: contactValue,
      }

      try {
        const response = await fetch(FORMSPARK_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })

        if (!response.ok) {
          throw new Error('FormSpark submission failed')
        }

        /* ---------------------------
         SUCCESS → RESET + SHOW MESSAGE
      --------------------------- */
        form.reset()
        contactFieldWrapper.classList.remove('gift-drawer-field--mobile', 'gift-drawer-field--email')

        successP.classList.add('gift-drawer__success--active')
      } catch (error) {
        errorP.textContent = 'Something went wrong. Please try again.'
        errorP.classList.add('gift-drawer__error--active')
        console.error(error)
      }
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  // Open drawer on hamburger click
  document.querySelector('.hamburger').addEventListener('click', () => {
    document.querySelector('.nav-drawer--primary').classList.add('nav-drawer--active')
  })

  // Close drawer when clicking outside the drawer content
  document.querySelectorAll('.nav-drawer').forEach((drawer) => {
    drawer.addEventListener('click', () => {
      drawer.classList.remove('nav-drawer--active')
    })
  })

  // Prevent closing when clicking inside the drawer content
  document.querySelectorAll('.nav-drawer__box').forEach((box) => {
    box.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  })

  // Close drawer when clicking the close button
  document.querySelectorAll('.nav-drawer__close').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      btn.closest('.nav-drawer').classList.remove('nav-drawer--active')
    })
  })

  document.querySelectorAll('.nav-drawer-section__header').forEach((header) => {
    header.addEventListener('click', (e) => {
      const section = header.closest('.nav-drawer-section')
      const body = section.querySelector('.nav-drawer-section__body')
      const image = header.querySelector('.nav-drawer-section__image')

      // If no body or we're on desktop (image is hidden), follow the link
      const href = header.getAttribute('href')
      const isImageHidden = image && window.getComputedStyle(image).display === 'none'

      if (!body || isImageHidden) {
        if (href && href !== '#') {
          window.location.href = href
        }
        return
      }

      // On mobile: handle slide toggle behavior
      e.preventDefault()

      const isOpen = body.classList.contains('open')

      // Collapse all others
      document.querySelectorAll('.nav-drawer-section').forEach((sec) => {
        const bodyEl = sec.querySelector('.nav-drawer-section__body')
        if (!bodyEl) return

        sec.classList.remove('nav-drawer-section--active')
        bodyEl.style.maxHeight = '0px'
        bodyEl.classList.remove('open')
      })

      // Expand if not already open
      if (!isOpen) {
        body.style.maxHeight = body.scrollHeight + 'px'
        body.classList.add('open')
        section.classList.add('nav-drawer-section--active')
      }
    })
  })

  const header = document.querySelector('.header')
  const navDrawerPrimary = document.querySelector('.nav-drawer--primary')
  const navDrawerBundles = document.querySelector('.nav-drawer--bundles')

  // Get nav links
  const allMenuLinks = document.querySelectorAll('.header-menu-link')
  const allItemsLink = document.querySelector('.header-menu-link[href="/collections/all-items"]')
  const bundlesLink = document.querySelector('.header-menu-link[href="/pages/gift-sets"]')

  // Utility to deactivate all drawers
  function hideAllDrawers() {
    navDrawerPrimary.classList.remove('nav-drawer--active')
    navDrawerBundles.classList.remove('nav-drawer--active')
  }

  // Show correct drawer on hover
  allMenuLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      const href = link.getAttribute('href')
      hideAllDrawers()

      if (href === '/collections/all-items') {
        navDrawerPrimary.classList.add('nav-drawer--active')
      } else if (href.includes('/pages/gift-sets')) {
        navDrawerBundles.classList.add('nav-drawer--active')
      }
    })
  })

  // Hide all drawers when leaving the header
  header.addEventListener('mouseleave', () => {
    hideAllDrawers()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-slider"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('.hero-banner-slider .embla');
  if (!root) return;

  // Create autoplay plugin separately so we can reset it
  const autoplay = EmblaCarouselAutoplay();

  const embla = EmblaCarousel(root.querySelector('.hero-banner-slider .embla__viewport'), { loop: true }, [
    autoplay,
    EmblaCarouselFade(),
  ]);

  const prev = root.querySelector('.hero-banner-slider .embla__prev');
  const next = root.querySelector('.hero-banner-slider .embla__next');

  prev.addEventListener('click', () => {
    embla.scrollPrev();
    autoplay.reset();
  });

  next.addEventListener('click', () => {
    embla.scrollNext();
    autoplay.reset();
  });

  const setArrowState = () => {
    prev.disabled = !embla.canScrollPrev();
    next.disabled = !embla.canScrollNext();
  };

  const dotsWrap = root.querySelector('.hero-banner-slider .embla__dots');

  const buildDots = () => {
    dotsWrap.innerHTML = Array.from(
      { length: embla.slideNodes().length },
      () => '<button class="embla__dot" type="button"><span class="embla__dot-inner"></span></button>'
    ).join('');
    dotsWrap.querySelectorAll('.hero-banner-slider .embla__dot').forEach((dot, i) =>
      dot.addEventListener('click', () => {
        embla.scrollTo(i);
        autoplay.reset();
      })
    );
  };

  const selectDot = () => {
    const selectedIndex = embla.selectedScrollSnap();
    dotsWrap.querySelectorAll('.embla__dot').forEach((dot, index) => {
      const isSelected = index === selectedIndex;
      dot.classList.toggle('is-selected', isSelected);
      dot.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      dot.setAttribute('tabindex', isSelected ? '0' : '-1');
    });
  };

  const refresh = () => {
    buildDots();
    setArrowState();
    selectDot();
  };

  embla
    .on('init', refresh)
    .on('reInit', refresh)
    .on('select', () => {
      setArrowState();
      selectDot();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  // Debounce helper
  function debounce(func, delay) {
    let timeout
    return function (...args) {
      clearTimeout(timeout)
      timeout = setTimeout(() => func.apply(this, args), delay)
    }
  }

  // --- Quantity Selectors (debounced, by item key) ---
  document.querySelectorAll('.new-cart-item').forEach((itemEl) => {
    const key = itemEl.dataset.key
    const input = itemEl.querySelector('.new-cart-quantity__value')
    const btnUp = itemEl.querySelector('.new-cart-quantity__up')
    const btnDown = itemEl.querySelector('.new-cart-quantity__down')

    if (!key || !input || !btnUp || !btnDown) return

    const updateQty = debounce(async (newQty) => {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: newQty,
          }),
        })

        if (!res.ok) throw new Error('Cart update failed')

        const cart = await res.json()
        if (newQty === 0 && cart.item_count === 0) {
          wunderkindSDK('emptyCart', {})
        }

        location.reload() // reload after final update
      } catch (err) {
        console.error('Error updating quantity:', err)
      }
    }, 400) // wait 400ms after last click

    btnUp.addEventListener('click', () => {
      const currentQty = parseInt(input.value, 10) || 1
      input.value = currentQty + 1
      updateQty(parseInt(input.value, 10))
    })

    btnDown.addEventListener('click', () => {
      const currentQty = parseInt(input.value, 10) || 1
      const newQty = Math.max(0, currentQty - 1)
      input.value = newQty
      updateQty(newQty)
    })
  })

  // Remove items
  document.querySelectorAll('.new-cart-item__remove').forEach((el) => {
    el.addEventListener('click', (e) => {
      const cartEl = document.querySelector('.new-cart')
      const itemCount = parseInt(cartEl?.dataset.itemCount, 10)
      const href = el.getAttribute('href')

      if (itemCount === 1 && href) {
        e.preventDefault()
        wunderkindSDK('emptyCart', {})
        setTimeout(() => {
          window.location.href = href
        }, 500)
      }
    })
  })

  // --- Giftwrap quantity controls (local only, no AJAX) ---
  document.querySelectorAll('.new-cart-wrap').forEach((wrap) => {
    const input = wrap.querySelector('.new-cart-quantity__value')
    const up = wrap.querySelector('.new-cart-quantity__up')
    const down = wrap.querySelector('.new-cart-quantity__down')
    if (!input || !up || !down) return

    up.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 1
      input.value = current + 1
    })
    down.addEventListener('click', () => {
      const current = parseInt(input.value, 10) || 1
      input.value = Math.max(1, current - 1)
    })
  })

  // --- Accordions ---
  const accordions = document.querySelectorAll('.new-cart-accordion')
  accordions.forEach((accordion) => {
    const header = accordion.querySelector('.new-cart-accordion__header')
    const body = accordion.querySelector('.new-cart-accordion__body')
    const isDefaultOpen = accordion.classList.contains('is-default-open')
    if (isDefaultOpen) {
      body.style.maxHeight = body.scrollHeight + 'px'
      body.style.overflow = 'hidden'
    }
    header.addEventListener('click', () => {
      const isOpen = accordion.classList.contains('is-open')
      if (isOpen) {
        accordion.classList.remove('is-open')
        body.style.maxHeight = null
      } else {
        accordion.classList.add('is-open')
        body.style.maxHeight = body.scrollHeight + 'px'
      }
    })
  })

  // --- Gift message save ---
  const giftTextarea = document.querySelector('#giftmessage')
  const giftAccordion = giftTextarea?.closest('.new-cart-accordion')
  if (giftTextarea) {
    if (giftTextarea.value.trim().length > 0 && giftAccordion) {
      giftAccordion.classList.add('is-open')
      const body = giftAccordion.querySelector('.new-cart-accordion__body')
      if (body) body.style.maxHeight = body.scrollHeight + 'px'
    }
    let typingTimeout
    giftTextarea.addEventListener('input', () => {
      clearTimeout(typingTimeout)
      typingTimeout = setTimeout(async () => {
        const note = giftTextarea.value.trim()
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note }),
          })
          if (!res.ok) throw new Error('Failed to save gift message')
          console.log('Gift message saved:', note)
        } catch (err) {
          console.error('Error saving gift message:', err)
        }
      }, 600)
    })
  }

  // --- Discount codes ---
  const form = document.querySelector('.new-cart-discounts__form')
  const input = document.querySelector('.new-cart-discounts__input')
  const discountList = document.querySelector('.new-cart-discounts__codes')
  const errorEl = document.querySelector('.new-cart-discounts__error')

  if (form && input) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault()
      errorEl.textContent = ''
      errorEl.classList.remove('new-cart-discounts__error--active')

      const newCode = input.value.trim()
      if (!newCode) {
        errorEl.classList.add('new-cart-discounts__error--active')
        errorEl.textContent = 'Please enter a discount code.'
        return
      }
      const existingCodes = Array.from(discountList.querySelectorAll('.new-cart-code__name')).map((el) =>
        el.textContent.trim()
      )
      if (existingCodes.includes(newCode)) {
        errorEl.classList.add('new-cart-discounts__error--active')
        errorEl.textContent = 'That code is already applied.'
        return
      }
      const allCodes = [...existingCodes, newCode].join(',')
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: allCodes }),
        })
        if (!res.ok) throw new Error('Failed to apply code')
        const json = await res.json()
        const applied = json.discount_codes?.find(
          (d) => d.code?.toUpperCase() === newCode.toUpperCase() && d.applicable
        )
        if (!applied) {
          errorEl.classList.add('new-cart-discounts__error--active')
          errorEl.textContent = 'Invalid or expired discount code.'
          return
        }
        location.reload()
      } catch (err) {
        console.error(err)
        errorEl.classList.add('new-cart-discounts__error--active')
        errorEl.textContent = 'Something went wrong. Please try again.'
      }
    })
  }

  // --- Remove discount codes ---
  document.querySelectorAll('.new-cart-code__remove').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const discountList = document.querySelector('.new-cart-discounts__codes')
      const codeToRemove = btn.closest('.new-cart-code').querySelector('.new-cart-code__name').textContent.trim()
      const remainingCodes = Array.from(discountList.querySelectorAll('.new-cart-code__name'))
        .map((el) => el.textContent.trim())
        .filter((code) => code !== codeToRemove)
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingCodes.join(',') }),
        })
        if (!res.ok) throw new Error('Failed to remove code')
        location.reload()
      } catch (err) {
        console.error(err)
        const errorEl = document.querySelector('.new-cart-discounts__error')
        errorEl.classList.add('new-cart-discounts__error--active')
        errorEl.textContent = 'Error removing discount code. Please try again.'
      }
    })
  })

  // --- Embroidery quantity sync (debounced, tied to main items) ---
  async function updateCartItemQuantityByKey(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      })
      if (!res.ok) throw new Error('Cart update failed')
      return await res.json()
    } catch (err) {
      console.error('Error updating embroidery quantity:', err)
    }
  }

  function syncEmbroideryQuantities() {
    const embroideryItem = document.querySelector('.new-cart-item[data-is-embroidery="true"]')
    if (!embroideryItem) return

    const embroideryKey = embroideryItem.dataset.key
    const productItems = document.querySelectorAll('.new-cart-item:not([data-is-embroidery="true"])')

    // debounce so we don’t spam updates
    const debouncedUpdate = debounce(async (qty) => {
      if (qty <= 0) {
        // remove embroidery entirely
        await updateCartItemQuantityByKey(embroideryKey, 0)
      } else {
        await updateCartItemQuantityByKey(embroideryKey, qty)
      }
    }, 300)

    productItems.forEach((item) => {
      const input = item.querySelector('.new-cart-quantity__value')
      const up = item.querySelector('.new-cart-quantity__up')
      const down = item.querySelector('.new-cart-quantity__down')
      if (!input || !up || !down) return

      const syncEmbroidery = () => {
        const qty = parseInt(input.value, 10) || 0
        debouncedUpdate(qty)
      }

      up.addEventListener('click', syncEmbroidery)
      down.addEventListener('click', syncEmbroidery)
    })
  }

  document.addEventListener('DOMContentLoaded', syncEmbroideryQuantities)

  // --- Pairings variant logic (same as Ajax cart) ---
  document.querySelectorAll('.new-cart-pair').forEach((pair) => {
    const select = pair.querySelector('.new-cart-pair__select')
    const img = pair.querySelector('.new-cart-pair__img')
    const priceEl = pair.querySelector('.new-cart-pair__price')
    const addBtn = pair.querySelector('.new-cart-pair__add')

    // Store product JSON for variant info
    const productHandle = pair.querySelector('a')?.getAttribute('href')?.split('/products/')[1]
    if (!select || !img || !priceEl || !productHandle) return

    // Fetch full product JSON (Shopify exposes this)
    fetch(`/products/${productHandle}.js`)
      .then((res) => res.json())
      .then((product) => {
        select.addEventListener('change', (e) => {
          const variantId = parseInt(e.target.value, 10)
          const variant = product.variants.find((v) => v.id === variantId)
          if (!variant) return

          // Update image
          if (variant.featured_image) {
            img.src = variant.featured_image.src + '&width=500'
          } else if (product.featured_image) {
            img.src = product.featured_image + '&width=500'
          }

          // Update price
          priceEl.textContent = Shopify.formatMoney(variant.price, Shopify.money_format).replace('.00', '')

          // Update availability
          if (variant.available) {
            addBtn.disabled = false
            addBtn.textContent = 'Add'
          } else {
            addBtn.disabled = true
            addBtn.textContent = 'Unavailable'
          }
        })
      })
      .catch((err) => console.error('Error loading product JSON:', err))
  })

  // Bogos booster position
  try {
    Shopify.scaHandleConfigValue = {
      bogos_progressing_bar_query: '.main-cart-gift-progress',
      bogos_custom_progress_position: 'in', //before/in/after,
    }
  } catch (err) {}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // SORT BY SELECT
    const sortBy = document.getElementById('sort-by')

    if (sortBy) {
      const qp = {}

      // Preserve existing query parameters
      if (location.search.length > 1) {
        const params = location.search.substring(1).split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')
          if (key) {
            qp[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }

      // Update sort_by query parameter on change
      sortBy.addEventListener('change', function (e) {
        qp.sort_by = e.target.value
        location.search = new URLSearchParams(qp).toString()
      })
    }

    // GRID TYPE TOGGLE
    const gridTypeButtons = document.querySelectorAll('.main-collection-grid-type')
    const grid = document.querySelector('.main-collection-grid')

    gridTypeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active state from all buttons
        gridTypeButtons.forEach((btn) => btn.classList.remove('main-collection-grid-type--active'))

        // Activate clicked button
        this.classList.add('main-collection-grid-type--active')

        // Toggle grid layout
        if (this.classList.contains('main-collection-grid-type--threes')) {
          grid?.classList.add('main-collection-grid--3')
        } else {
          grid?.classList.remove('main-collection-grid--3')
        }
      })
    })

    const form = document.querySelector('#filters')
    if (!form) return

    const applyButton = document.querySelector('.main-collection-sidebar__footer-apply')
    const clearButton = document.querySelector('.main-collection-sidebar__footer-clear')
    const isMobile = () => window.innerWidth < 800

    const sliderEl = document.getElementById('price-slider')
    const hiddenMin = document.getElementById('price-min')
    const hiddenMax = document.getElementById('price-max')
    const displayMin = document.getElementById('range-display-min')
    const displayMax = document.getElementById('range-display-max')

    const defaultMin = 0
    const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100', 10) : 100

    /* ----------------------------
     FILTER COUNT
  ---------------------------- */
    function updateFilterCount() {
      const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length

      const minVal = parseInt(hiddenMin?.value || '0', 10)
      const maxVal = parseInt(hiddenMax?.value || '0', 10)

      const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

      const totalFilters = checkedCount + (priceSelected ? 1 : 0)

      if (applyButton) {
        applyButton.innerHTML = `Apply Filters (${totalFilters})`
      }
    }

    /* ----------------------------
     APPLY / BUILD URL
  ---------------------------- */
    function buildURLFromFilters() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      // Remove existing filter params
      Array.from(params.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          params.delete(key)
        }
      })

      // Add checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value)
      })

      // Price filters
      const priceMin = form.querySelector('input[name="filter.v.price.gte"]')
      const priceMax = form.querySelector('input[name="filter.v.price.lte"]')

      if (priceMin && priceMin.value !== '') {
        params.set('filter.v.price.gte', priceMin.value)
      }

      if (priceMax && priceMax.value !== '') {
        params.set('filter.v.price.lte', priceMax.value)
      }

      // Search query
      const searchInput = form.querySelector('input[name="q"]')
      if (searchInput && searchInput.value) {
        params.set('q', searchInput.value)
      }

      // Preserve Shopify prefix option
      const prefix = url.searchParams.get('options[prefix]')
      if (prefix) {
        params.set('options[prefix]', prefix)
      }

      return `${window.location.pathname}?${params.toString()}`
    }

    function applyFilters() {
      window.location.href = buildURLFromFilters()
    }

    /* ----------------------------
     CHECKBOX EVENTS
  ---------------------------- */
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        updateFilterCount()
        if (!isMobile()) {
          applyFilters()
        }
      })
    })

    /* ----------------------------
     APPLY / CLEAR BUTTONS
  ---------------------------- */
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFilters()
      })
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false
        })

        if (sliderEl && sliderEl.noUiSlider) {
          sliderEl.noUiSlider.set([defaultMin, defaultMax])
        }

        updateFilterCount()

        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    /* ----------------------------
     PRICE SLIDER
  ---------------------------- */
    if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax && window.noUiSlider) {
      const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)

      const startMin = parseInt(hiddenMin.value || defaultMin, 10)
      const startMax = parseInt(hiddenMax.value || max, 10)

      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          min: 0,
          max: 300,
        },
        step: 1,
      })

      sliderEl.noUiSlider.on('update', function (values) {
        const min = Math.round(values[0])
        const max = Math.round(values[1])

        displayMin.textContent = min
        displayMax.textContent = max
        hiddenMin.value = min
        hiddenMax.value = max

        updateFilterCount()
      })

      sliderEl.noUiSlider.on('change', function () {
        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    updateFilterCount()

    /* ----------------------------
     SORT DROPDOWN
  ---------------------------- */
    const sortSelect = document.querySelector('#sort_by')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        params.set('sort_by', this.value)
        window.location.href = `${window.location.pathname}?${params.toString()}`
      })
    }

    /* ----------------------------
     FILTER SIDEBAR TOGGLE
  ---------------------------- */
    const filtersToggle = document.querySelector('.main-collection-info__filters')
    const filtersSidebar = document.querySelector('.main-collection-sidebar')
    const filtersClose = document.querySelector('.main-collection-sidebar__close')

    if (filtersToggle && filtersSidebar && filtersClose) {
      filtersToggle.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.toggle('main-collection-sidebar--active')
      })

      filtersClose.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.remove('main-collection-sidebar--active')
      })
    }

    /* ----------------------------
     DROPDOWNS
  ---------------------------- */
    document.querySelectorAll('.main-collection-dropdown').forEach((dropdown) => {
      const header = dropdown.querySelector('.main-collection-dropdown__header')
      const body = dropdown.querySelector('.main-collection-dropdown__body')
      if (!header || !body) return

      dropdown.classList.add('main-collection-dropdown--active')
      body.style.maxHeight = body.scrollHeight + 'px'

      header.addEventListener('click', function () {
        const isActive = dropdown.classList.toggle('main-collection-dropdown--active')

        body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
      })
    })

    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]')
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids')
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        })
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-instructions"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.instructions-video').forEach((card) => {
      const video = card.querySelector('video');
      const playBtn = card.querySelector('.instructions-video__play');
      if (!video || !playBtn) return;

      playBtn.setAttribute('role', 'button');
      playBtn.setAttribute('tabindex', '0');

      const startPlayback = () => {
        video.setAttribute('controls', 'controls');
        playBtn.style.display = 'none';
        video.setAttribute('playsinline', '');
        video.play().catch(() => {
          video.setAttribute('controls', 'controls');
        });
      };

      // Play when clicking play button
      playBtn.addEventListener('click', startPlayback);
      playBtn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          startPlayback();
        }
      });

      // Play when clicking directly on video
      video.addEventListener('click', () => {
        if (video.paused) {
          startPlayback();
        }
      });

      // Reset overlay when paused or ended
      const resetOverlay = () => {
        if (video.ended || video.paused) {
          video.removeAttribute('controls');
          playBtn.style.display = 'flex';
        }
      };
      video.addEventListener('ended', resetOverlay);
      video.addEventListener('pause', resetOverlay);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.main-product-bundles');
    if (!root) return;

    // Bundles
    const moneyFormat = root.getAttribute('data-money-format');
    const moneyFormatExample = root.getAttribute('data-money-format-example');

    function closeAllSelects() {
      document
        .querySelectorAll('.main-product-bundles-select')
        .forEach((sel) => sel.classList.remove('main-product-bundles-select--active'));
    }

    function recalcBundleTotals() {
      const selectedEls = document.querySelectorAll('.main-product-bundles-select__selected');
      const addBtn = document.querySelector('.main-product-bundles__add');
      if (!selectedEls.length || !addBtn) return;

      const discountPercent = Number(addBtn.dataset.discountPercent || 0) / 100;
      let originalTotal = 0;
      let bundleAvailable = true;

      selectedEls.forEach((selected) => {
        const productData = JSON.parse(selected.dataset.product);
        const variantId = Number(selected.dataset.variantId);
        const variant = productData.variants.find((v) => v.id === variantId);
        if (!variant) return;

        originalTotal += variant.price;
        if (!variant.available) bundleAvailable = false;
      });

      const discountedTotal = Math.round(originalTotal * (1 - discountPercent));

      addBtn.querySelector('.main-product-bundles__add-price').textContent = window.formatMoneyLatest(
        moneyFormat,
        moneyFormatExample,
        discountedTotal,
        true
      );

      addBtn.querySelector('.main-product-bundles__add-compare').textContent = window.formatMoneyLatest(
        moneyFormat,
        moneyFormatExample,
        originalTotal,
        true
      );

      addBtn.disabled = !bundleAvailable;
      addBtn.querySelector('.main-product-bundles__add-text').textContent = bundleAvailable
        ? 'Add to Cart'
        : 'Out of Stock';
    }

    const selects = document.querySelectorAll('.main-product-bundles-select');
    if (!selects.length) return;

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.main-product-bundles-select')) closeAllSelects();
    });

    selects.forEach((select) => {
      const selected = select.querySelector('.main-product-bundles-select__selected');
      const options = select.querySelectorAll(
        '.main-product-bundles-select__options .main-product-bundles-select__option'
      );

      if (!selected || !options.length) return;

      selected.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = select.classList.contains('main-product-bundles-select--active');
        closeAllSelects();
        if (!isOpen) select.classList.add('main-product-bundles-select--active');
      });

      options.forEach((option) => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();

          const variantId = option.dataset.variantId;
          if (!variantId) return;

          // Checked state
          options.forEach((o) => o.classList.remove('main-product-bundles-select__option--checked'));
          option.classList.add('main-product-bundles-select__option--checked');

          // Update variant id
          selected.dataset.variantId = variantId;

          // Update title
          const nextTitle = option.querySelector('.main-product-bundles-select__option-title')?.textContent || '';
          const selectedTitleEl = selected.querySelector('.main-product-bundles-select__option-title');
          if (selectedTitleEl) selectedTitleEl.textContent = nextTitle;

          // Update swatch
          const newSwatchImg = option.querySelector('.main-product-bundles-select__option-swatch img');
          const selectedSwatchEl = selected.querySelector('.main-product-bundles-select__option-swatch');
          if (selectedSwatchEl) {
            selectedSwatchEl.innerHTML = newSwatchImg ? newSwatchImg.outerHTML : '';
          }

          // ✅ Update SOLD OUT badge in the selected row
          const productData = JSON.parse(selected.dataset.product);
          const variant = productData.variants.find((v) => v.id === Number(variantId));

          const selectedRow = selected.querySelector('.main-product-bundles-select__option');
          const existingSold = selectedRow?.querySelector('.main-product-bundles-select__sold');

          if (variant && !variant.available) {
            if (!existingSold && selectedRow) {
              const sold = document.createElement('div');
              sold.className = 'main-product-bundles-select__sold';
              sold.textContent = 'Sold out';
              selectedRow.appendChild(sold);
            }
          } else {
            if (existingSold) existingSold.remove();
          }

          // Update mini product image
          const img = option
            .closest('.main-product-bundles__product')
            ?.querySelector('.main-product-bundles__product-image img');

          if (img && variant?.featured_image?.src) {
            img.src = variant.featured_image.src.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/, '$1?width=300');
          }

          recalcBundleTotals();
          select.classList.remove('main-product-bundles-select--active');
        });
      });
    });

    recalcBundleTotals();

    const addBtn = document.querySelector('.main-product-bundles__add');
    if (!addBtn) return;

    addBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;

      const textEl = addBtn.querySelector('.main-product-bundles__add-text');
      const originalText = textEl.textContent;

      addBtn.disabled = true;
      textEl.textContent = 'Adding';

      const items = [];
      document.querySelectorAll('.main-product-bundles-select__selected').forEach((sel) => {
        const id = Number(sel.dataset.variantId);
        if (id) items.push({ id, quantity: 1 });
      });

      try {
        console.log('-----------------------');

        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        console.log('items.added');
        if (!res.ok) throw new Error('Cart add failed');

        // ✅ BUNDLR ENABLED
        if (window.bndlr?.getCheckoutInfo) {
          window.bndlr.getCheckoutInfo(async ({ code }) => {
            if (code) {
              const newCode = code.trim().toUpperCase();
              const existingCodes = Array.from(document.querySelectorAll('.ac-new-discount-code__name')).map((el) =>
                el.textContent.trim().toUpperCase()
              );

              if (!existingCodes.includes(newCode)) {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ discount: [...existingCodes, newCode].join(',') }),
                });
              }
            }

            await window.acUpdateContent?.();
            window.acOpenCart?.();
            addBtn.disabled = false;
            textEl.textContent = originalText;
          });
        }
        // ✅ BUNDLR DISABLED
        else {
          await window.acUpdateContent?.();
          window.acOpenCart?.();
          addBtn.disabled = false;
          textEl.textContent = originalText;
        }
      } catch (err) {
        console.error(err);
        await window.acUpdateContent();
        window.acOpenCart?.();
        addBtn.disabled = false;
        textEl.textContent = originalText;
      }
    });

    // Embla
    const viewport = root.querySelector('.embla__viewport');
    const thumbs = root.querySelectorAll('.main-product-new-image-thumbnail');
    const dotsContainer = root.querySelector('.embla__dots');
    const prevBtn = root.querySelector('.embla__button--prev');
    const nextBtn = root.querySelector('.embla__button--next');

    if (!viewport) return;

    const embla = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

    // Dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      embla.slideNodes().forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'embla__dot';
        dot.type = 'button';
        dot.addEventListener('click', () => embla.scrollTo(i));
        dotsContainer.appendChild(dot);
      });
    }

    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        embla.scrollNext();
      });
    }

    function syncUI() {
      const index = embla.selectedScrollSnap();

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.embla__dot').forEach((dot, i) => {
          dot.classList.toggle('is-selected', i === index);
        });
      }

      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('main-product-new-image-thumbnail--active', i === index);
      });
    }

    embla.on('select', syncUI);
    syncUI();

    // Thumbnail click
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.emblaIndex);
        if (!isNaN(index)) embla.scrollTo(index);
      });
    });

    // Accordions

    const bundleAccordions = root.querySelectorAll('.main-product-bundles__accordion');

    bundleAccordions.forEach((accordion) => {
      const header = accordion.querySelector('.main-product-bundles__accordion-header');
      const body = accordion.querySelector('.main-product-bundles__accordion-body');

      if (!header || !body) return;

      header.addEventListener('click', () => {
        const isActive = accordion.classList.contains('main-product-bundles__accordion--active');

        // Close all other accordions (optional, matches PDP behavior)
        bundleAccordions.forEach((acc) => {
          acc.classList.remove('main-product-bundles__accordion--active');
          const accBody = acc.querySelector('.main-product-bundles__accordion-body');
          if (accBody) accBody.style.maxHeight = '0';
        });

        // Toggle this accordion
        if (!isActive) {
          accordion.classList.add('main-product-bundles__accordion--active');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"] && !Shopify.designMode) return;
  try {
    
  // State
  let emblaInstance = null;

  // Elements
  const rootEl = document.querySelector('.main-product-new');
  const idControl = rootEl.querySelector('[name="id"]');

  const allEmblaWrappers = rootEl.querySelectorAll('.embla-wrapper');
  const swatchInputs = rootEl.querySelectorAll('.swatch__input');
  const price = rootEl.querySelector('.main-product-new-content__price');
  const compare = rootEl.querySelector('.main-product-new-content__compare');
  const selectedOptionLabels = rootEl.querySelectorAll('.main-product-new-content__option-label-selection');
  const add = rootEl.querySelector('.main-product-new-content__add');
  const pairingBlocks = document.querySelectorAll('.main-product-new-content__pairing');
  const accordions = document.querySelectorAll('.main-product-new-content__accordion');
  const allPrevBtns = document.querySelectorAll('.embla__button--prev');
  const allNextBtns = document.querySelectorAll('.embla__button--next');
  const tushbabyTooltip = rootEl.querySelector('.tushbaby-lite-tooltip');

  // Data
  const productJsonString = document.querySelector('#product-json').textContent;
  const productData = JSON.parse(productJsonString);
  const productInventoryJsonString = document.querySelector('#product-inventory').textContent;
  const productInventoryJson = JSON.parse(productInventoryJsonString);
  const variantData = productData.variants;
  const moneyFormat = rootEl.getAttribute('data-money-format');
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example');
  const lowInventoryThresholdString = rootEl.getAttribute('data-low-inventory-threshold');
  const lowInventoryThreshold = lowInventoryThresholdString ? Number(lowInventoryThresholdString) : 150;

  // Events
  swatchInputs.forEach((input) => {
    input.addEventListener('change', () => {
      const matchedVariant = findMatchingVariant();
      if (!matchedVariant) return;

      const swatches = input.closest('.main-product-new-content__option-swatches');
      const fieldset = swatches.parentElement;
      const legend = swatches.previousElementSibling;
      const label = legend.querySelector('.main-product-new-content__option-label-selection');
      const optionIndex = swatches.getAttribute('data-option-index');

      label.textContent = matchedVariant[`option${Number(optionIndex) + 1}`];

      if (idControl && idControl.value !== matchedVariant.id.toString()) {
        handleVariantChange(matchedVariant);
      }
    });
  });

  // Thumbnail click → scroll Embla and update active state
  document.querySelectorAll('.main-product-new-image-thumbnail').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = parseInt(thumb.getAttribute('data-embla-index'));
      if (emblaInstance && !isNaN(index)) {
        emblaInstance.scrollTo(index);
      }

      // Clear active class from all thumbnails in the same block
      const thumbnailGroup = thumb.closest('.main-product-new-image-thumbnails');
      thumbnailGroup.querySelectorAll('.main-product-new-image-thumbnail').forEach((el) => {
        el.classList.remove('main-product-new-image-thumbnail--active');
      });

      // Set active class on clicked thumbnail
      thumb.classList.add('main-product-new-image-thumbnail--active');
    });
  });

  // Attach arrow event listeners once on page load
  allPrevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollPrev();
    });
  });

  allNextBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (emblaInstance) emblaInstance.scrollNext();
    });
  });

  // Helpers
  function updateActiveThumbnail(variantId) {
    const selectedIndex = emblaInstance.selectedScrollSnap();

    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
    if (!activeThumbBlock) return;

    const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
    allThumbs.forEach((thumb, i) => {
      if (i === selectedIndex) {
        thumb.classList.add('main-product-new-image-thumbnail--active');
      } else {
        thumb.classList.remove('main-product-new-image-thumbnail--active');
      }
    });
  }

  function handleVariantChange(newVariant) {
    if (!idControl) return;

    // Change input value
    idControl.value = newVariant.id;

    // Change the url
    setUrlParam('variant', newVariant.id);

    // Update the carousel
    initEmblaForVariant(newVariant.id.toString());

    // Update thumbnails
    rootEl.querySelectorAll('.main-product-new-image-thumbnails').forEach((thumbBlock) => {
      thumbBlock.classList.remove('main-product-new-image-thumbnails--active');
    });
    const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${newVariant.id}`);
    if (activeThumbBlock) {
      activeThumbBlock.classList.add('main-product-new-image-thumbnails--active');

      // Set the active slide
      activeThumbBlock.querySelectorAll(`.main-product-new-image-thumbnail`).forEach((el, i) => {
        if (i == 0) {
          el.classList.add('main-product-new-image-thumbnail--active');
        } else {
          el.classList.remove('main-product-new-image-thumbnail--active');
        }
      });
    }

    // Update the price
    price.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.price);
    compare.textContent = formatMoney(moneyFormat, moneyFormatExample, newVariant.compare_at_price);

    if (newVariant.compare_at_price > newVariant.price) {
      price.classList.add('main-product-new-content__price--active');
      compare.classList.add('main-product-new-content__compare--active');
    } else {
      price.classList.remove('main-product-new-content__price--active');
      compare.classList.remove('main-product-new-content__compare--active');
    }

    // Update preorder
    const preorderActiveClass = 'main-product-new-content__preorder-notice--active';

    rootEl.querySelectorAll('.main-product-new-content__preorder-notice').forEach((el) => {
      el.classList.remove(preorderActiveClass);
    });

    const preorder = rootEl.querySelector(`.main-product-new-content__preorder-notice--${newVariant.id}`);

    if (preorder) {
      preorder.classList.add(preorderActiveClass);
    }

    // Update low inventory
    const lowInventoryEl = rootEl.querySelector('.main-product-new__low-inventory');
    if (lowInventoryEl) {
      const lowInventoryActiveClass = 'main-product-new__low-inventory--active';
      const variantInventory = productInventoryJson[newVariant.id];

      if (variantInventory < lowInventoryThreshold && variantInventory > 0) {
        lowInventoryEl.textContent = 'ONLY A FEW LEFT';
        lowInventoryEl.classList.add(lowInventoryActiveClass);
      } else {
        lowInventoryEl.textContent = '';
        lowInventoryEl.classList.remove(lowInventoryActiveClass);
      }
    }

    function updateAccordionContent(type, variantId, defaultClass, accordionSelector) {
      // Remove all active states
      rootEl.querySelectorAll(`.main-product-new-content__${type}`).forEach((el) => {
        el.classList.remove(`main-product-new-content__${type}--active`);
      });

      // Activate variant-specific or fallback
      const variantBlock = document.querySelector(`.main-product-new-content__${type}--${variantId}`);
      if (variantBlock) {
        variantBlock.classList.add(`main-product-new-content__${type}--active`);
      } else {
        const defaultBlock = document.querySelector(`.main-product-new-content__${defaultClass}`);
        if (defaultBlock) defaultBlock.classList.add(`main-product-new-content__${type}--active`);
      }

      // Recalculate accordion height only if open
      const accordion = document.querySelector(accordionSelector);
      if (accordion && accordion.classList.contains('main-product-new-content__accordion--active')) {
        const body = accordion.querySelector('.main-product-new-content__accordion-body');
        if (body) body.style.maxHeight = body.scrollHeight + 'px';
      }
    }

    updateAccordionContent(
      'details',
      newVariant.id,
      'details--default',
      '.main-product-new-content__accordion--description'
    );
    updateAccordionContent(
      'materials',
      newVariant.id,
      'materials--default',
      '.main-product-new-content__accordion--materials'
    );
    updateAccordionContent('safety', newVariant.id, 'safety--default', '.main-product-new-content__accordion--safety');

    // Update the add button
    if (newVariant.available) {
      if (preorder) {
        add.textContent = 'Pre-Order Now';
      } else {
        add.textContent = 'Add to Cart';
      }
      add.disabled = false;
    } else {
      add.textContent = 'Out of Stock';
      add.disabled = true;
    }

    // Update variant notes
    const noteCls = 'main-product-new-content__variant-note';
    const noteActiveCls = noteCls + '--active';
    const newNote = document.querySelector(`.${noteCls}--${newVariant.id}`);
    const oldNote = document.querySelector(`.${noteActiveCls}`);

    if (oldNote) oldNote.classList.remove(noteActiveCls);
    if (newNote) newNote.classList.add(noteActiveCls);

    // Update the embroidery image
    const embroideryWrapCls = 'main-product-new-embroidery-wrap';
    const embroideryWrap = document.querySelector(`.${embroideryWrapCls}`);

    if (embroideryWrap) {
      const embroideryWrapActiveCls = 'main-product-new-embroidery-wrap--active';
      const baseFabricCls = 'main-product-new-embroidery__fabric';
      const embroideryFabric = rootEl.querySelector(`.${baseFabricCls}--${newVariant.id}`);

      if (embroideryFabric) {
        // Display section
        document.querySelector(`.${embroideryWrapCls}`).classList.add(embroideryWrapActiveCls);

        // Display correct fabric image
        rootEl.querySelectorAll(`.${baseFabricCls}--active`).forEach((el) => {
          el.classList.remove(`${baseFabricCls}--active`);
        });
        embroideryFabric.classList.add(`${baseFabricCls}--active`);
      } else {
        // Hide section
        document.querySelector(`.${embroideryWrapCls}`).classList.remove(embroideryWrapActiveCls);
        document.querySelector('.main-product-new-embroidery').classList.remove('main-product-new-embroidery--active');

        // Hide embroidery-specific thumbnails
        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'none';
        });

        // Untick toggle
        document.querySelector(`.main-product-new-embroidery-toggle__checkbox`).checked = false;

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.getElementById('embroidery-text').removeAttribute('name');
      }
    }

    // Update tooltip
    if (tushbabyTooltip) {
      if (newVariant.id === 40092713287746) {
        tushbabyTooltip.classList.add('tushbaby-lite-tooltip--active');
      } else {
        tushbabyTooltip.classList.remove('tushbaby-lite-tooltip--active');
      }
    }

    // Send variant wunderkind event
    try {
      const variant = findMatchingVariant();

      // wunderkindSDK('viewItem', {
      //   'item:id': `item-${productData.id}`,
      //   'item:itemgroupid': `group-item-${productData.id}`,
      // })

      wunderkindSDK('selectItem', {
        'item:id': `${productData.id}`,
        'item:itemgroupid': `${productData.id}`,
        'item:feedid': `${variant.id}`,
      });
    } catch (err) {
      console.log('Failed to send wunderkind:', err);
    }
  }

  function initEmblaForVariant(variantId) {
    // Hide all Embla wrappers
    allEmblaWrappers.forEach((wrapper) => {
      wrapper.style.display = wrapper.dataset.variantId === variantId ? 'block' : 'none';
    });

    // Destroy previous instance
    if (emblaInstance) emblaInstance.destroy();

    // Find the correct viewport
    const targetWrapper = document.querySelector(`.embla-wrapper[data-variant-id="${variantId}"]`);
    const viewport = targetWrapper.querySelector('.embla__viewport');

    if (viewport) {
      requestAnimationFrame(() => {
        emblaInstance = EmblaCarousel(viewport, { loop: false }, [EmblaCarouselFade()]);

        // Setup dots
        const dotsContainer = targetWrapper.querySelector('.embla__dots');
        const slideCount = emblaInstance.slideNodes().length;
        dotsContainer.innerHTML = ''; // Clear previous dots

        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.classList.add('embla__dot');
          dot.type = 'button';
          dot.addEventListener('click', () => emblaInstance.scrollTo(i));
          dotsContainer.appendChild(dot);
        }

        function updateUI() {
          const selectedIndex = emblaInstance.selectedScrollSnap();

          // Update thumbnails
          const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${variantId}`);
          if (activeThumbBlock) {
            const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail');
            allThumbs.forEach((thumb, i) => {
              thumb.classList.toggle('main-product-new-image-thumbnail--active', i === selectedIndex);
            });
          }

          // Update dots
          const allDots = dotsContainer.querySelectorAll('.embla__dot');
          allDots.forEach((dot, i) => {
            dot.classList.toggle('is-selected', i === selectedIndex);
          });

          // 🎥 Autoplay video in active slide
          const allSlides = emblaInstance.slideNodes();
          allSlides.forEach((slide, i) => {
            const video = slide.querySelector('video');
            if (video) {
              if (i === selectedIndex) {
                video.muted = true; // required for autoplay in most browsers
                video.loop = true;
                video.play().catch(() => {}); // prevent errors if not allowed
              } else {
                video.pause();
                video.currentTime = 0; // reset if you want it to start fresh
              }
            }
          });
        }

        emblaInstance.on('select', updateUI);
        updateUI();
      });
    }
  }

  function findMatchingVariant() {
    const optionFields = document.querySelectorAll('.main-product-new-content__option');
    const selectedValues = [];

    optionFields.forEach((field, i) => {
      const checked = field.querySelector('input:checked');
      if (checked) selectedValues[i] = checked.value;
    });

    return variantData.find((variant) => {
      return selectedValues.every((val, i) => variant[`option${i + 1}`] === val);
    });
  }

  // Pairings
  pairingBlocks.forEach((pairingBlock) => {
    // Parse pairing product JSON
    const productData = JSON.parse(pairingBlock.dataset.json);

    const selectEl = pairingBlock.querySelector('select[name="id"]');
    const priceEl = pairingBlock.querySelector('.main-product-new-content__pairing-main-top p');
    const imageEl = pairingBlock.querySelector('.main-product-new-content__pairing-image img');
    const addButton = pairingBlock.querySelector('button[type="submit"]');

    const updatePairingUI = (variantId) => {
      const variant = productData.variants.find((v) => v.id == Number(variantId));
      if (!variant) return;

      // Update price
      priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '');

      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src + '&width=130';
        imageEl.alt = variant.featured_image.alt || productData.title;
      } else if (productData.featured_image) {
        imageEl.src = productData.featured_image.src + '&width=130';
        imageEl.alt = productData.featured_image.alt || productData.title;
      }

      // Update add button (disabled if out of stock)
      if (variant.available) {
        addButton.disabled = false;
        addButton.textContent = 'Add';
      } else {
        addButton.disabled = true;
        addButton.textContent = 'Sold Out';
      }
    };

    // On select change
    selectEl.addEventListener('change', (e) => {
      updatePairingUI(e.target.value);
    });
  });

  // Accordions
  accordions.forEach((accordion) => {
    const header = accordion.querySelector('.main-product-new-content__accordion-header');
    const body = accordion.querySelector('.main-product-new-content__accordion-body');

    header.addEventListener('click', () => {
      const isActive = accordion.classList.contains('main-product-new-content__accordion--active');

      if (isActive) {
        // Close accordion
        accordion.classList.remove('main-product-new-content__accordion--active');
        body.style.maxHeight = '0';
      } else {
        // Open accordion
        accordion.classList.add('main-product-new-content__accordion--active');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });

  // Embroidery
  const embroidery = document.querySelector('.main-product-new-embroidery');

  if (embroidery && idControl) {
    const embroideryActiveCls = 'main-product-new-embroidery--active';
    const embroideryOptions = document.querySelector('.main-product-new-embroidery');
    const embroideryToggle = document.querySelector('#embroidery__checkbox');

    embroideryToggle.addEventListener('change', (e) => {
      if (e.target.checked) {
        embroidery.classList.add(embroideryActiveCls);

        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'block';
        });

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.setAttribute('name', 'properties[Embroidery font]');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.setAttribute('name', 'properties[Embroidery color]');
        });

        document.getElementById('embroidery-text').setAttribute('name', 'properties[Embroidery text]');

        // if (emblaInstance) {
        //   const lastIndex = emblaInstance.slideNodes().length - 1
        //   const secondToLastIndex = Math.max(0, lastIndex - 1)
        //   emblaInstance.scrollTo(secondToLastIndex)

        //   const activeThumbBlock = rootEl.querySelector(`.main-product-new-image-thumbnails--${idControl.value}`)
        //   if (activeThumbBlock) {
        //     const allThumbs = activeThumbBlock.querySelectorAll('.main-product-new-image-thumbnail')
        //     allThumbs.forEach((thumb) => {
        //       thumb.classList.remove('main-product-new-image-thumbnail--active')
        //     })

        //     const targetThumb = allThumbs[secondToLastIndex]
        //     if (targetThumb) {
        //       targetThumb.classList.add('main-product-new-image-thumbnail--active')
        //     }
        //   }
        // }
      } else {
        embroidery.classList.remove(embroideryActiveCls);

        document.querySelectorAll('[data-embroidery-thumb]').forEach((el) => {
          el.style.display = 'none';
        });

        document.querySelectorAll('.main-product-new-embroidery__font input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.querySelectorAll('.main-product-new-embroidery__color input').forEach((input) => {
          input.removeAttribute('name');
        });

        document.getElementById('embroidery-text').removeAttribute('name');
      }
    });

    // Thread color
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery color]"]')) {
        const color = event.target.value.toLowerCase();

        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove('black', 'silver', 'gold');
        preview.classList.add(color);
      }
    });

    // Font
    document.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Embroidery font]"]')) {
        const font = event.target.value.toLowerCase().replace(' ', '-');

        const preview = document.getElementById('embroidery-text-preview');
        preview.classList.remove('font-helvetica', 'font-athletic-flair', 'font-flair');
        preview.classList.add(`font-${font}`);
      }
    });

    // Live text
    document.getElementById('embroidery-text').addEventListener('keyup', function (event) {
      const value = event.target.value;

      const preview = document.getElementById('embroidery-text-preview');
      preview.textContent = value;

      const charCount = value.length;
      let fontSize = 70;
      if (charCount > 4) fontSize -= charCount * 2;

      preview.style.fontSize = fontSize + 'px';
    });
  }

  // Init on first load
  if (idControl) initEmblaForVariant(idControl.value);

  // Wunderkind initial item views
  try {
    wunderkindSDK('item', {
      id: `${productData.id}`,
      copy: productData?.title,
      category: 'Global',
      url: window.location.origin + window.location.pathname,
      imageurl: 'https:' + productData?.featured_image,
      instock: productData?.available ? 'true' : 'false',
    });

    const variant = findMatchingVariant();

    wunderkindSDK('viewItem', {
      'item:id': `${productData.id}`,
      'item:itemgroupid': `${productData.id}`,
    });
  } catch (err) {
    console.log('Failed to send wunderkind:', err);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    // SORT BY SELECT
    const sortBy = document.getElementById('sort-by')

    if (sortBy) {
      const qp = {}

      // Preserve existing query parameters
      if (location.search.length > 1) {
        const params = location.search.substring(1).split('&')

        params.forEach((param) => {
          const [key, value] = param.split('=')
          if (key) {
            qp[decodeURIComponent(key)] = decodeURIComponent(value || '')
          }
        })
      }

      // Update sort_by query parameter on change
      sortBy.addEventListener('change', function (e) {
        qp.sort_by = e.target.value
        location.search = new URLSearchParams(qp).toString()
      })
    }

    // GRID TYPE TOGGLE
    const gridTypeButtons = document.querySelectorAll('.main-collection-grid-type')
    const grid = document.querySelector('.main-collection-grid')

    gridTypeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        // Remove active state from all buttons
        gridTypeButtons.forEach((btn) => btn.classList.remove('main-collection-grid-type--active'))

        // Activate clicked button
        this.classList.add('main-collection-grid-type--active')

        // Toggle grid layout
        if (this.classList.contains('main-collection-grid-type--threes')) {
          grid?.classList.add('main-collection-grid--3')
        } else {
          grid?.classList.remove('main-collection-grid--3')
        }
      })
    })

    const form = document.querySelector('#filters')
    if (!form) return

    const applyButton = document.querySelector('.main-collection-sidebar__footer-apply')
    const clearButton = document.querySelector('.main-collection-sidebar__footer-clear')
    const isMobile = () => window.innerWidth < 800

    const sliderEl = document.getElementById('price-slider')
    const hiddenMin = document.getElementById('price-min')
    const hiddenMax = document.getElementById('price-max')
    const displayMin = document.getElementById('range-display-min')
    const displayMax = document.getElementById('range-display-max')

    const defaultMin = 0
    const defaultMax = hiddenMax ? parseInt(hiddenMax.defaultValue || '100', 10) : 100

    /* ----------------------------
     FILTER COUNT
  ---------------------------- */
    function updateFilterCount() {
      const checkedCount = form.querySelectorAll('input[type="checkbox"]:checked').length

      const minVal = parseInt(hiddenMin?.value || '0', 10)
      const maxVal = parseInt(hiddenMax?.value || '0', 10)

      const priceSelected = minVal !== defaultMin || maxVal !== defaultMax

      const totalFilters = checkedCount + (priceSelected ? 1 : 0)

      if (applyButton) {
        applyButton.innerHTML = `Apply Filters (${totalFilters})`
      }
    }

    /* ----------------------------
     APPLY / BUILD URL
  ---------------------------- */
    function buildURLFromFilters() {
      const url = new URL(window.location.href)
      const params = new URLSearchParams(url.search)

      // Remove existing filter params
      Array.from(params.keys()).forEach((key) => {
        if (key.startsWith('filter.')) {
          params.delete(key)
        }
      })

      // Add checked checkboxes
      form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
        params.append(input.name, input.value)
      })

      // Price filters
      const priceMin = form.querySelector('input[name="filter.v.price.gte"]')
      const priceMax = form.querySelector('input[name="filter.v.price.lte"]')

      if (priceMin && priceMin.value !== '') {
        params.set('filter.v.price.gte', priceMin.value)
      }

      if (priceMax && priceMax.value !== '') {
        params.set('filter.v.price.lte', priceMax.value)
      }

      // Search query
      const searchInput = form.querySelector('input[name="q"]')
      if (searchInput && searchInput.value) {
        params.set('q', searchInput.value)
      }

      // Preserve Shopify prefix option
      const prefix = url.searchParams.get('options[prefix]')
      if (prefix) {
        params.set('options[prefix]', prefix)
      }

      return `${window.location.pathname}?${params.toString()}`
    }

    function applyFilters() {
      window.location.href = buildURLFromFilters()
    }

    /* ----------------------------
     CHECKBOX EVENTS
  ---------------------------- */
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', function () {
        updateFilterCount()
        if (!isMobile()) {
          applyFilters()
        }
      })
    })

    /* ----------------------------
     APPLY / CLEAR BUTTONS
  ---------------------------- */
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        applyFilters()
      })
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
          input.checked = false
        })

        if (sliderEl && sliderEl.noUiSlider) {
          sliderEl.noUiSlider.set([defaultMin, defaultMax])
        }

        updateFilterCount()

        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    /* ----------------------------
     PRICE SLIDER
  ---------------------------- */
    if (sliderEl && hiddenMin && hiddenMax && displayMin && displayMax && window.noUiSlider) {
      const max = parseInt(sliderEl.dataset.max || hiddenMax.defaultValue || '100', 10)

      const startMin = parseInt(hiddenMin.value || defaultMin, 10)
      const startMax = parseInt(hiddenMax.value || max, 10)

      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          min: 0,
          max: 300,
        },
        step: 1,
      })

      sliderEl.noUiSlider.on('update', function (values) {
        const min = Math.round(values[0])
        const max = Math.round(values[1])

        displayMin.textContent = min
        displayMax.textContent = max
        hiddenMin.value = min
        hiddenMax.value = max

        updateFilterCount()
      })

      sliderEl.noUiSlider.on('change', function () {
        if (!isMobile()) {
          applyFilters()
        }
      })
    }

    updateFilterCount()

    /* ----------------------------
     SORT DROPDOWN
  ---------------------------- */
    const sortSelect = document.querySelector('#sort_by')
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        params.set('sort_by', this.value)
        window.location.href = `${window.location.pathname}?${params.toString()}`
      })
    }

    /* ----------------------------
     FILTER SIDEBAR TOGGLE
  ---------------------------- */
    const filtersToggle = document.querySelector('.main-collection-info__filters')
    const filtersSidebar = document.querySelector('.main-collection-sidebar')
    const filtersClose = document.querySelector('.main-collection-sidebar__close')

    if (filtersToggle && filtersSidebar && filtersClose) {
      filtersToggle.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.toggle('main-collection-sidebar--active')
      })

      filtersClose.addEventListener('click', function (e) {
        e.preventDefault()
        filtersSidebar.classList.remove('main-collection-sidebar--active')
      })
    }

    /* ----------------------------
     DROPDOWNS
  ---------------------------- */
    document.querySelectorAll('.main-collection-dropdown').forEach((dropdown) => {
      const header = dropdown.querySelector('.main-collection-dropdown__header')
      const body = dropdown.querySelector('.main-collection-dropdown__body')
      if (!header || !body) return

      dropdown.classList.add('main-collection-dropdown--active')
      body.style.maxHeight = body.scrollHeight + 'px'

      header.addEventListener('click', function () {
        const isActive = dropdown.classList.toggle('main-collection-dropdown--active')

        body.style.maxHeight = isActive ? body.scrollHeight + 'px' : '0px'
      })
    })

    // Wunderkind
    try {
      const collection = document.querySelector('[data-collection-ids]')
      if (collection) {
        const ids = collection.getAttribute('data-collection-ids')
        window.wunderkindSDK('viewCategory', {
          'items:ids': ids.split(',').filter((item) => item !== ''),
          'page:url': window.location.href,
        })
      }
    } catch (err) {
      console.log('Failed to send wunderkind data', err)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-also"] && !Shopify.designMode) return;
  try {
    
  const rootEl = document.querySelector('.product-also')
  if (!rootEl) return

  const moneyFormat = rootEl.getAttribute('data-money-format')
  const moneyFormatExample = rootEl.getAttribute('data-money-format-example')

  // Product Also Blocks
  document.querySelectorAll('.product-also-product').forEach((productBlock) => {
    const productData = JSON.parse(productBlock.dataset.json)
    const selectEl = productBlock.querySelector('select[name="id"]')
    const priceEl = productBlock.querySelector('p')
    const imageEl = productBlock.querySelector('img')
    const addButton = productBlock.querySelector('button[type="submit"]')

    const updateProductAlsoUI = (variantId) => {
      const variant = productData.variants.find((v) => {
        return v.id === Number(variantId)
      })
      if (!variant) return

      // Update price
      priceEl.textContent = formatMoney(moneyFormat, moneyFormatExample, variant.price).replace('.00', '')

      // Update image
      if (variant.featured_image) {
        imageEl.src = variant.featured_image.src + '&width=750'
        imageEl.alt = variant.featured_image.alt || productData.title
      } else if (productData.featured_image) {
        imageEl.src = productData.featured_image.src + '&width=750'
        imageEl.alt = productData.featured_image.alt || productData.title
      }

      // Update add button
      if (variant.available) {
        addButton.disabled = false
        addButton.textContent = 'Add to Cart'
      } else {
        addButton.disabled = true
        addButton.textContent = 'Sold Out'
      }
    }

    // On select change
    selectEl.addEventListener('change', (e) => {
      updateProductAlsoUI(e.target.value)
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const viewport = document.querySelector('.testimonials .embla__viewport')
  const dotsContainer = document.querySelector('.testimonials .embla__dots')

  if (!viewport || !dotsContainer) return

  let embla
  let dots = []

  const getSlidesToScroll = () => {
    const width = window.innerWidth
    if (width >= 1040) return 3
    if (width >= 600) return 2
    return 1
  }

  const setupEmbla = () => {
    if (embla) embla.destroy()

    embla = EmblaCarousel(viewport, {
      loop: false,
      align: 'start',
      containScroll: 'trimSnaps',
      slidesToScroll: getSlidesToScroll(),
    })

    generateDots()
    embla.on('select', updateDots)
    embla.on('reInit', () => {
      generateDots()
      updateDots()
    })
    updateDots()
  }

  /* ---------- CHANGED #1 ---------- */
  const generateDots = () => {
    dotsContainer.innerHTML = ''
    const pageCount = embla.scrollSnapList().length

    dots = Array.from({ length: pageCount }, (_, index) => {
      const dot = document.createElement('button')
      dot.classList.add('embla__dot')
      dot.type = 'button'
      dot.id = `testimonial-tab-${index}`
      dot.setAttribute('role', 'tab')
      dot.setAttribute('aria-controls', `testimonial-panel-${index}`)
      dot.setAttribute('aria-selected', index === 0 ? 'true' : 'false')
      dot.setAttribute('tabindex', index === 0 ? '0' : '-1')
      dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`)
      dot.addEventListener('click', () => embla.scrollTo(index))
      dotsContainer.appendChild(dot)
      return dot
    })
  }

  /* ---------- CHANGED #3 ---------- */
  const updateDots = () => {
    const selectedIndex = embla.selectedScrollSnap()
    dots.forEach((dot, index) => {
      const isSelected = index === selectedIndex
      dot.classList.toggle('is-selected', isSelected)
      dot.setAttribute('aria-selected', isSelected ? 'true' : 'false')
      dot.setAttribute('tabindex', isSelected ? '0' : '-1')
    })
  }

  setupEmbla()
  window.addEventListener('resize', setupEmbla)

  } catch(e) { console.error(e); }
})();
})();
